import React from 'react';
import {
	TableContainer,
	Table,
	TableHead,
	TableRow,
	TableCell,
	Paper,
} from '@material-ui/core';
import NumberFormat from 'react-number-format';
import { useTranslation } from 'react-i18next';

const LoanCalculation = ({ loan }) => {
	const { t } = useTranslation();
	return (
		<div style={{ marginTop: 15 }}>
			<TableContainer component={Paper}>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>{t('property-value')}</TableCell>
							<TableCell>
								<NumberFormat
									value={
										loan.data.breakdown &&
										loan.data.breakdown.propertyValueLimit
									}
									thousandSeparator={true}
									displayType={'text'}
									prefix={'Rwf '}
								/>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell>{t('maximum-deductible')}</TableCell>
							<TableCell>
								<NumberFormat
									value={
										loan.data.breakdown && loan.data.breakdown.deductableIncome
									}
									thousandSeparator={true}
									displayType={'text'}
									prefix={'Rwf '}
								/>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell>{t('interest')}</TableCell>
							<TableCell>
								<NumberFormat
									decimalScale={2}
									displayType={'text'}
									value={
										loan.data.breakdown && loan.data.breakdown.interest * 100
									}
									suffix={'%'}
								/>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell>{t('period')}</TableCell>
							<TableCell>
								{loan.data.breakdown && loan.data.breakdown.years} years
							</TableCell>
						</TableRow>
					</TableHead>
				</Table>
			</TableContainer>
		</div>
	);
};

export default LoanCalculation;
